<!-- eslint-disable vue/no-unused-refs -->
<template>
  <div :class="['components-page__newExamineApprove', getClass]">
    <QSScrollerBox
      v-loading="loading"
      class="components-page__newExamineApprove-scroll"
    >
      <approveHeader
        ref="approveHeader"
        :active.sync="active"
        :isDisabled="isDisabled"
      />
      <approvalContent
        :active.sync="active"
        :isDisabled="isDisabled"
      />
      <approvalFooter
        slot="bottomAction"
        @onNext="onNext"
        @onPrev="onPrev"
        :active.sync="active"
        :isDisabled="isDisabled"
      />
    </QSScrollerBox>
  </div>
</template>
<script>
import mixin from '../../mixins/auditFlowManage'
import approveHeader from './components/approveHeader'
import approvalContent from './components/approvalContent.vue'
import approvalFooter from './components/approvalFooter.vue'

// 页面涉及枚举值映射关系参考文件地址：src/views/approval/config/auditFlowManage
export default {
  name: 'auditFlowManage',
  mixins: [mixin],
  components: {
    approveHeader,
    approvalContent,
    approvalFooter,
  },
  data() {
    const { id, organizationId, bizType } = this.$route.query
    const isDisabled =
      location.href.indexOf('detail') > -1 ? 'all-disabled' : ''
    return {
      active: 0,
      loading: false,
      id: Number(id),
      organizationId: Number(organizationId),
      bizType: Number(bizType),
      isDisabled,
    }
  },
  computed: {
    getClass() {
      if (this.active === 1) {
        return 'dark'
      }
      return 'light'
    },
  },
  methods: {
    onNext() {
      this.active += 1
    },
    onPrev() {
      this.active -= 1
    },
  },
  created() {
    const { id, bizType, organizationId } = this

    try {
      this.loading = true
      Promise.all([
        // 获取审批流详情
        this.$store.dispatch('getAuditDetail', { id, bizType }),
        // 获取审批人
        this.$store.dispatch('getAccountListAction', {
          organizationId,
          queryAll: 1,
        }),
        // 获取模版详情
        this.$store.dispatch('getTemplateDetail', { bizType, organizationId }),
      ])
    } finally {
      this.loading = false
    }
  },
}
</script>
<style lang="scss" scoped>
.components-page__newExamineApprove {
  position: relative;
  height: 100%;
  width: 100%;
  &-scroll {
    width: 100%;
    // position: relative;
    // overflow: auto;
    // position: absolute;
    // bottom: 0;
    // left: 0;
    // right: 0;
    // top: 0;
  }
}
.light {
  background: #fff;
}
.dark {
  background: #f7f8fa;
}
</style>
